<template>
  <Fragment>
    <a
      v-if="this.general.userId"
      :href="linkHref"
      target="_blank"
      :alt="linkAlt"
      v-tooltip="tooltip"
    >
      <i v-if="icon == 'A4' || icon == 'A3'" class="fas fa-print"></i>
      <img v-else :src="iconSrc" alt="Tisk" />
      {{ cta }}
    </a>

    <span
      v-else
      v-tooltip="'Pro možnost tisku je nutné být přihlášený.'"
      class="disabled"
      >&times; {{ cta }}</span
    >
  </Fragment>
</template>

<script>
import { mapState } from 'vuex';
import { Fragment } from 'vue-fragment';

export default {
  props: {
    cta: {
      type: String,
      required: true
    },
    linkAlt: {
      type: String,
      required: true
    },
    linkHref: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'A4'
    }
  },
  components: {
    Fragment
  },
  computed: {
    ...mapState(['general']),
    iconSrc: function () {
      return `/vue/icons/${this.icon}.svg`;
    }
  }
};
</script>

<style scoped>
a {
  margin: 0 0.3em;
}
img {
  display: inline-block;
  margin-bottom: -0.15em;
}
.disabled {
  cursor: not-allowed;
  text-decoration: underline;
  color: #aebfce;
  font-style: italic;
}
</style>
